import Modal from 'modal-enhanced-react-native-web'
export const wrap = c => c
export default Modal
